import request from './request';
import requestWithoutTimeout from './requestWithoutTimeout';

const productService = {
  getAll: (params) =>
    request.get('dashboard/admin/products/paginate', { params }),
  getReportPaginate: (params) =>
    request.get('dashboard/admin/products/report/paginate', { params }),
  getById: (id, params, config) =>
    request.get(`dashboard/admin/products/${id}`, { params, ...config }),
  import: (data) =>
    requestWithoutTimeout.post('dashboard/admin/products/import', data),
  create: (data) => request.post('dashboard/admin/products', data),
  /** PUT application/json — partial updates; see docs/PRODUCT_UPDATE_FRONTEND_INTEGRATION.md */
  update: (uuid, data) =>
    request.put(`dashboard/admin/products/${uuid}`, data),
  delete: (data) =>
    request.delete(`dashboard/admin/products/delete`, { data }),
  deleteByUuid: (uuid) =>
    request.delete(`dashboard/admin/products/${uuid}`),
  dropAll: () => request.get(`dashboard/admin/products/drop/all`),
  restoreAll: () => request.get(`dashboard/admin/products/restore/all`),
  stocks: (uuid, data) =>
    request.post(`dashboard/admin/products/${uuid}/stocks`, data),
  updateStock: (id, data) =>
    request.put(`dashboard/admin/stocks/${id}`, data),
  properties: (uuid, data) =>
    request.post(`dashboard/admin/products/${uuid}/properties`, data),
  setActive: (uuid) =>
    request.post(`dashboard/admin/products/${uuid}/active`, {}),
  getStock: (params) =>
    request.get(`dashboard/admin/stocks/select-paginate`, { params }),
  getStockReport: (params) =>
    request.get(`dashboard/admin/stocks/report/paginate`, { params }),
  updateStatus: (uuid, data) =>
    request.post(`dashboard/admin/products/${uuid}/status/change`, data),
  updateStocks: (data) =>
    request.post(`dashboard/admin/stocks/galleries`, data),
};

export default productService;
